import { getHostUrl } from "@/composables/store";
import { useUser } from "@/stores/user";

export function useSavedFilingCount() {
	const savedFilingCount = useState<number>("ucc-saved-filing-count", () => 0);
	const savedFilingCountLoaded = useState<boolean>("ucc-saved-filing-count-loaded", () => false);
	const sequence = useState<number>("ucc-saved-filing-count-sequence", () => 0);
	// Capture Nuxt context before delayed middleware callbacks run.
	const userStore = useUser();
	const apiBase = getHostUrl();

	async function loadSavedFilingCount() {
		if (!userStore.token || userStore.user?.access_ucc !== true) return savedFilingCount.value;
		const requestSequence = ++sequence.value;
		try {
			const response = await fetch(`${apiBase}/ucc/saved-filings?limit=1&offset=0`, {
				headers: { Authorization: `Bearer ${userStore.token}` },
			});
			if (!response.ok) throw new Error(`Saved filing count request failed (${response.status})`);
			const payload = await response.json();
			if (requestSequence !== sequence.value) return savedFilingCount.value;
			if (payload?.success !== true || !Number.isFinite(Number(payload.total))) throw new Error("Invalid saved filing count response");
			savedFilingCount.value = Math.max(0, Number(payload.total));
			savedFilingCountLoaded.value = true;
		} catch (error) {
			console.error("Unable to load saved filing count", error);
		}
		return savedFilingCount.value;
	}

	return { savedFilingCount, savedFilingCountLoaded, loadSavedFilingCount };
}
